<div class="d-flex flex-column gap-3" *ngIf="!contactSectionHidden">
  <span class="changes-title" i18n>Primary Contact Information</span>
  <div class="changes-container">
    <app-submission-details-field-changes
      *ngIf="!contactPreviousNotApplicable; else previousNotApplicable"
      [changeType]="SubmissionDetailsFieldChangeTypeEnum.Previous"
      [detailsChanges]="contactPrevious" />

    <app-submission-details-field-changes
      *ngIf="!contactNewNotApplicable; else newNotApplicable"
      [changeType]="SubmissionDetailsFieldChangeTypeEnum.New"
      [detailsChanges]="contactNew" />
  </div>
</div>

<ng-template #previousNotApplicable>
  <div class="changes-card">
    <span class="changes-title" i18n>Previous</span>
    <span class="not-applicable" i18n>Not Applicable</span>
  </div>
</ng-template>

<ng-template #newNotApplicable>
  <div class="changes-card">
    <span class="changes-title" i18n>New</span>
    <span class="not-applicable" i18n>Not Applicable</span>
  </div>
</ng-template>
